const config = {
  // Use environment variable if defined, otherwise fallback to your production URL
  url: process.env.REACT_APP_API_URL || 'https://sidhisochsidhibaat.com',
  
  // reCAPTCHA site key from environment variables
  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY
};

export default config;